module.exports = __webpack_public_path__ + "img/booster3.d15c0f3c.png";